import { migrationContext } from '../../migrationUsersBranchView.poeditor';

export const migrationResultKeys = {
  errorTitle: `${migrationContext}-mbConfirmationMessageErrorTitle`,
  errorDescription: `${migrationContext}-mbConfirmationMessageErrorDescription`,
  errorButtonText: `${migrationContext}-mbMigrationGoToGlobalPositionLink`,
  successTitle: `${migrationContext}-mbConfirmationMessageSuccessTitle`,
  successDescription: `${migrationContext}-mbConfirmationMessageSuccessDescription`,
  successButtonText: `${migrationContext}-mbMigrationUnderstoodLink`,
};
